<template>
  <v-container 
    fluid
  >
    <v-row 
      justify = "center"
    >
      <v-col 
        cols = "6" 
        md   = "4" 
        sm   = "8"
      >
        
        <v-card 
          outlined
        >
            <v-card-title 
              :class = "`justify-space-between ${head.color} pa-0 white--text`"
            >
              <v-icon 
                small 
                color  = "white"
                class  = "ml-1"
                @click = "$router.back()"
              >
                mdi-arrow-left-circle
              </v-icon>
              <span               
              >
                {{ $ml.get(head.title) }}
              </span>
              <span></span>
           </v-card-title>
          <v-card-text
            class = "pa-2" 
          >
            <v-row
              v-show = "show.profile"
            >
              <template 
                v-for = "(item_field, idx_field) of info_fields"
              >
                <v-col
                  :key = "idx_field"
                  cols = "12"
                >
                  
                  <v-text-field 
                    dense
                    outlined
                    hide-details
                    :label              = "$ml.get(item_field.text)" 
                    v-model             = "user_data[item_field.key]" 
                    :type               = "item_field.type" 
                    :prepend-inner-icon = "item_field.icon" 
                    :disabled           = "item_field.is_edit && edit ? true : 
                                          item_field.disabled ? true : false"
                    :class              = "`pa-0 ${item_field.class}`"
                  ></v-text-field>           
                </v-col>
              </template>
            </v-row>
            <form>
              
            <v-row
              v-show = "show.change_pwd"
            >
              
                
              <template 
                v-for = "(item_field, idx_field) of info_passw_fields"
              >
                <v-col
                  :key = "idx_field + ' password'"
                  cols = "12"
                >
                  
                  <v-text-field 
                    dense
                    outlined
                    hide-details
                    :label              = "$ml.get(item_field.text)" 
                    v-model             = "user_data[item_field.key]" 
                    :type               = "item_field.type" 
                    :prepend-inner-icon = "item_field.icon" 
                    :disabled           = "item_field.is_edit && edit ? true : 
                                          item_field.disabled ? true : false"
                    class               = "pa-0"
                    :name               = "item_field.key"
                    autocomplete        = "off"
                  ></v-text-field>           
                </v-col>
              </template>
              
            </v-row>
            </form>
        <v-card-actions>
          <v-progress-linear
            indeterminate
            v-show = "loading"
            color  = "primary"
          ></v-progress-linear>
            <v-btn 
              small
              v-show = "!loading"
              :color  = "show.change_pwd ? 'primary' : 'secondary'"               
              @click = "actions('change_password')"
            >
              {{ $ml.get(button.title) }}
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn 
              small
              v-show = "!loading && show.profile"              
              color  = "secondary" 
              @click = "edit =! edit" 
              v-text = "$ml.get('edit')"
            ></v-btn>
            <v-btn 
              small
              v-show = "!loading"
              color  = "success" 
              v-text = "$ml.get('save')"
              @click = "actions(button.action)"
            ></v-btn>
        </v-card-actions>
        </v-card-text>
        </v-card>
      </v-col>
    </v-row>    
  </v-container>
</template>

<script>
import axios from 'axios'
// import notifications from '@/components/info/notifications.vue'
export default {
  name       : 'profile',
  components : {
    // notifications
  },
  data: () => ({
    head        : {
      title  : 'profile',
      color  : 'primary',     
    },
    username    : 'ebenezer',
    first_names : 'Ebenezer',
    last_names  : 'Techs',
    email       : 'info@ebenezer.com',
    password    : 'password',
    user_data   : {},
    user_get    : null,
    edit        : true,
    inform      : null,
    info_fields : [
      {
        key  : "username",
        text : "username",
        type : "text",
        icon : "mdi-account",
        is_edit : false,
        disabled : true,
        class     : "mt-2"
      },
      {
        key  : "first_names",
        text : "first_names",
        type : "text",
        icon : "mdi-account-outline",
        is_edit : true

      },
      {
        key  : "last_names",
        text : "last_names",
        type : "text",
        icon : "mdi-clipboard-account",
        is_edit : true

      },
      {
        key  : "email",
        text : "email",
        type : "email",
        icon : "mdi-email",
        is_edit : true

      }   
      
    ],
    info_passw_fields : [
      {
        key  : "current_password",
        text : "current_password",
        type : "password",
        icon : "mdi-lock",
      },
      {
        key  : "password",
        text : "password",
        type : "password",
        icon : "mdi-lock",
      },
      {
        key  : "password1",
        text : "confirm_psw",
        type : "password",
        icon : "mdi-lock",
      },
    ],
    show              : {
      change_pwd : false,
      profile    : true,
    },
    loading      : false,
    button       : {
      action : 'save',
      title  : 'change_password',      
    },    
  }),
  created(){
    this.crud_user_profile('get');

  }, // created
  methods:{

    actions(act, item, opt){
      if (act == 'change_password') {
        if (this.head.title == 'profile') {
          this.head.title       = 'change_password';
          this.head.color       = 'success';          
          this.show.change_pwd  = true;
          this.show.profile     = false;
          this.button.title     = 'profile';
          if (this.user_data.current_password) delete this.user_data.current_password;
          if (this.user_data.password) delete this.user_data.password;
          if (this.user_data.password1) delete this.user_data.password1;

        }else{
          this.head.title       = 'profile';
          this.head.color       = 'primary';
          this.show.change_pwd  = false;
          this.show.profile     = true;
          this.button.title     = 'change_password';
          if (this.user_data) {

            if (this.user_data.current_password) delete this.user_data.current_password;
            if (this.user_data.password) delete this.user_data.password;
            if (this.user_data.password1) delete this.user_data.password1;
          }
        }

      }
      if (act == 'save'){
        if (this.title == 'profile') {
          this.crud_user_profile('put')
        }else{
          this.crud_user_profile('put', 'pwd')
        }
      }
    }, // actions

    crud_user_profile(option, pwd = false){
      const api = this.$URL + '/api/v1/users/';
      let jwt;
      if (localStorage.getItem('user')) {         
        jwt = JSON.parse(localStorage.getItem('user'));       
      }
      let user_local = null;
      let id_user    = null;
      let headrs     = null;
      if (jwt) {
        user_local = jwt.user;
        id_user    = user_local.id;
        headrs     = {
            "Authorization" : "Bearer " + jwt.jwt,
            "Content-Type"  : "application/json"
          }
        if (option == 'get') {

          this.user_data = {
            username    : user_local.Username,
            first_names : user_local.first_name,
            last_names  : user_local.last_name,
            email       : user_local.email,
            // password: '*******'
          }
        }
      }

    //https://github.com/axios/axios
    // console.log(jwt.jwt, 'jwt', user_local);
      // let headers ={
      //  "Authorization": "Bearer " + jwt.jwt,
      //  "Content-Type": "application/json"
      // }
    // change password
    if (pwd) {
      let info_up               = { ...this.user_data };
      info_up.first_access_pwd  = true;

      const api     = this.$URL + "/api/v1/auth/change_pwd";
      this.loading  = true;
      this.$axios.post(api, info_up).then(res => {
        this.loading  = false;
        this.$EventBus.$emit("notifications_modal",{
          type    : "success",
          message : this.$ml.get("your_pws_has_changed"),
        })
      }).catch(er => {
        this.loading  = false;
        console.log("Error change password ", er)
        this.$EventBus.$emit("notifications_modal",{
          type    : "error",
          message : er,
        })
      })
      
    }
    
    if (option == 'get') {

      axios[option]( api + id_user, {
        headers : headrs
      }).then( response => {
        let items     = response.data;
        this.user_get = items;
        console.log(response,' user data get')
      }).catch( error => {
        console.log(error, 'error')        
        this.$EventBus.$emit('notifications_modal',{
          type    : "error",
          message :  error && error.response && error.response.data ?  error.response.data.msg : error,
        });
      })
    }// get

    if (option == 'put') {
      let user_update           = this.user_data;
      this.user_get.first_name  = user_update.first_names;                              
      this.user_get.last_name   = user_update.last_names;
      this.user_get.email       = user_update.email;
      user_local.first_name     = user_update.first_names; 
      user_local.last_name      = user_update.last_names;
      user_local.email          = user_update.email;
      jwt.user                  = user_local;
      if (user_local.Username) {
        let jwt_changed = JSON.stringify(jwt)
        localStorage.setItem('user',jwt_changed);
      }

      axios[option](api + id_user, this.user_get, {
        headers : headrs
        }).then( response => {
          let items = response.data;
          console.log(response,' user data save')
          this.$EventBus.$emit('notifications_modal',{
            type : "updated"
          })                          
        }).catch( error => {
          console.log(error, 'error')
          this.$EventBus.$emit('notifications_modal',{
            type    : "error",
            message :  error && error.response && error.response.data ?  error.response.data.msg : error,
          });
        });

      }// save
    }, // 

  }, // methods
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    }, // currentUser
  },

  mounted() {
    // if (!this.currentUser) {
    //   this.$router.push('/login');
    // }
  }
};
</script>